import { gql } from 'graphql-request';
import { UserSettingsFragment } from '../fragments/fragments';

export const UPDATE_USER_SETTINGS_QUERY = gql`
  ${UserSettingsFragment}

  mutation UpdateUserSettings($updateUserInput: UpdateUserInput!) {
    updateUser(updateUserInput: $updateUserInput) {
      settings {
        ...UserSettingsFragment
      }
    }
  }
`;
